<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات ورژن"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="6">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="نسخه"
                      label-for="BuildNumber"
                    >
                      <b-form-input
                        id="BuildNumber"
                        v-model="Form.BuildNumber"
                        autocomplete="off"
                        type="number"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="پلتفرم"
                      label-for="Platform"
                    >
                      <v-select
                        v-model="Form.Platform"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Platform"
                        :clearable="false"
                        :options="enums('Platform')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="نوع"
                      label-for="Type"
                    >
                      <v-select
                        v-model="Form.Type"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Type"
                        :clearable="false"
                        :options="enums('VersionType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.Visibility"
                        name="Visibility"
                        value="true"
                        class="custom-control-success"
                      >
                        برای کاربر نمایش داده شود؟
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.ForceUpdate"
                        name="ForceUpdate"
                        value="true"
                        class="custom-control-danger"
                      >
                        آپدیت اجباری می باشد؟
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col
                    md="12"
                    class="mt-1"
                  >
                    <b-form-group
                      label="توضیحات"
                    />
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.Description"
                      :key="index"
                      class="mb-1"
                    >

                      <b-col cols="10">
                        <b-form-group
                          label-for="Description"
                        >
                          <b-form-input
                            id="Description"
                            v-model="Form.Description[index]"
                            name="Description"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <div>
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeVersionDetails(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </div>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col class="mb-1">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addVersionDetails"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'VersionDetails',
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Type: 0,
        Platform: 0,
        BuildNumber: null,
        Description: [],
        Visibility: true,
        ForceUpdate: false,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addVersionDetails()
    }
  },
  methods: {
    save() {
      let url = this.$api.version.add
      if (this.$route.params.id) {
        url = this.$api.version.update
      }

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.version.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addVersionDetails() {
      this.Form.Description.push(null)
    },
    removeVersionDetails(index) {
      this.Form.Description.splice(index, 1)
    },
  },
}
</script>
